import OilFiringInstallationForm from './OilFiringInstallationForm';
import OilFiringInstallationPDF from './OilFiringInstallationPDF';
import schema from './schema';
import validator from './validator';
import defaultData from './defaultData';
import { transformForPDF } from './transform';

export default {
  Form: OilFiringInstallationForm,
  PDF: OilFiringInstallationPDF,
  schema,
  validator,
  defaultData,
  transform: transformForPDF
};
